import { render, staticRenderFns } from "./skillsCompare.vue?vue&type=template&id=604b7711&scoped=true"
import script from "./skillsCompare.vue?vue&type=script&lang=js"
export * from "./skillsCompare.vue?vue&type=script&lang=js"
import style0 from "./skillsCompare.vue?vue&type=style&index=0&id=604b7711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b7711",
  null
  
)

export default component.exports